import { collection, getDocsFromServer, query, Timestamp, where } from "firebase/firestore";
import { db } from "../../../firebase";
import { summarizeIncomingAvailability } from "./incomingBookingAvailability";

const fetchIncomingBookingRecords = async (nodeId, first, last) => {
  const bookings = collection(db, "nodes", nodeId, "bookings");
  // Always read the server: cached bookings must not authorize a save.
  const snapshots = await Promise.all([
    getDocsFromServer(query(bookings,
      where("start", ">=", Timestamp.fromDate(new Date(`${first}T00:00:00+07:00`))),
      where("start", "<", Timestamp.fromDate(new Date(`${last}T00:00:00+07:00`))))),
    getDocsFromServer(query(bookings, where("start", ">=", first), where("start", "<", last))),
  ]);
  const records = new Map();
  snapshots.forEach((snapshot) => snapshot.docs.forEach((doc) => records.set(doc.id, { ...doc.data(), id: doc.id })));
  return Array.from(records.values());
};

export const fetchIncomingAvailability = async (nodeId, first, last, customer = "CHG03") =>
  summarizeIncomingAvailability(await fetchIncomingBookingRecords(nodeId, first, last), customer);

export const fetchIncomingBookingOverview = async (nodeId, first, last, customer = "CHG03") => {
  const bookings = await fetchIncomingBookingRecords(nodeId, first, last);
  return { days: summarizeIncomingAvailability(bookings, customer), bookings };
};
